module.exports = __webpack_public_path__ + "sun.5496dfe2.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/content/sun.svg
 ** module id = 114
 ** module chunks = 0
 **/